import {useEffect, useState} from 'react';

import type {Destructible} from './types';

export function useMobxStore<
  TStore extends Record<string, any> & Partial<Destructible>,
>(initializer: () => TStore): TStore {
  const [s] = useState(() => initializer());

  useEffect(() => {
    return () => {
      return s.destruct?.();
    };
  }, [s]);

  return s;
}
